import { nextTick } from "vue";
import router from "@/core/router/router";
import { vuexOidcCreateRouterMiddleware } from "vuex-oidc";
import store from "@/core/store/index";
import { PermissionGuard } from "@/core/plugins/permissions";
import { FeatureGuard } from "@/core/plugins/features";
import { AppMode, AppModule } from "@/core/store/modules/app-module";
import plausible from "../plausible";

const DEFAULT_TITLE = process.env.VUE_APP_TITLE as string;

router.afterEach(async (to: any) => {
  await nextTick(() => {
    document.title = to.meta.title ? `${to.meta.title} - ${DEFAULT_TITLE}` : DEFAULT_TITLE;
  });
});
router.afterEach(() => {
  plausible.trackPageview();
});

router.beforeEach(vuexOidcCreateRouterMiddleware(store));

router.beforeEach(async _to => {
  if (AppModule.configLoaded === false && AppModule.mode !== AppMode.Error) {
    await AppModule.GetConfig();
  }
  return true;
});

router.beforeEach(to => {
  const permissionValue = to.meta?.permission as string;
  if (permissionValue) {
    if (PermissionGuard(permissionValue)) {
      return true;
    } else {
      return {
        name: "Dashboard",
        query: { error: "Insufficient Permissions" }
      };
    }
  }
  return true;
});

router.beforeEach(to => {
  const featureValue = to.meta?.feature as string;
  if (featureValue) {
    if (FeatureGuard(featureValue) === "true") {
      return true;
    } else {
      return {
        name: "Dashboard",
        query: { error: "Feature Disabled" }
      };
    }
  }
  return true;
});
